import styled from "styled-components";
import * as colors from "../settings/colors";

export const H1 = styled.h1`
  color: ${colors.H1_TEXT};
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 29px;
  margin: 0;
`;

export const H2 = H1.withComponent("h2").extend`
  font-size: 18px;
  line-height: 21px;
  color: ${colors.H2_TEXT};
  letter-spacing: -0.37px;
`;

export default H1;



// WEBPACK FOOTER //
// ./src/components/Heading.js